export const environment = {
  production: false,
  apiUrl: 'https://suppliers.dev.psp.perc.cloud/api/v1',
};
